(() => {
  'use strict';
  const countryForm = document.getElementById('alarmiko-pl-market-form');
  const form = document.getElementById('alarmiko-product-form');
  const source = document.getElementById('alarmiko-product-data');
  const header = document.getElementById('header-component');
  function syncHeader() {
    if (header) header.dataset.menuStyle = window.innerWidth < 1100 ? 'drawer' : 'menu';
  }
  syncHeader();
  window.addEventListener('resize', syncHeader);
  if (window.Shopify?.currency?.active === 'PLN') {
    const exchange = Number(window.Shopify.currency.rate);
    if (Number.isFinite(exchange) && exchange > 0) {
      document.querySelectorAll('[data-alarmiko-shipping-eur]').forEach(label => {
        const threshold = Math.ceil(100 * Number(label.dataset.alarmikoShippingEur) * exchange) / 100;
        label.textContent = new Intl.NumberFormat('pl-PL', {style:'currency',currency:'PLN'}).format(threshold);
      });
    }
  }
  if (!form || !source || countryForm) return;
  const product = JSON.parse(source.textContent);
  const cards = [...document.querySelectorAll('#alarmiko-packages [data-alarmiko-pack]')];
  if (!product || cards.length !== 4 || product.variants.length !== 4) return;
  const button = form.querySelector('[type="submit"]');
  let current = 1;
  let busy = false;
  function select(index) {
    if (busy || !product.variants[index]) return;
    current = index;
    cards.forEach((card, i) => {
      card.classList.toggle('kaching-bundles__bar--selected', i === index);
      card.setAttribute('aria-checked', String(i === index));
      card.querySelector('input').checked = i === index;
    });
    const variant = product.variants[index];
    form.elements.namedItem('id').value = variant.id;
    form.elements.namedItem('properties[Zawartość zestawu]').value = (index + 1) + (index ? ' czujniki' : ' czujnik');
    button.disabled = !variant.available;
  }
  cards.forEach((card, index) => {
    card.addEventListener('click', () => select(index));
    card.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {e.preventDefault();select(index);}
    });
  });
  select(current);
  async function cart(path, payload) {
    const result = await fetch('/pl/' + path, payload ? {
      method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)
    } : {headers:{Accept:'application/json'},cache:'no-store'});
    const data = await result.json();
    if (!result.ok) throw new Error(data.description || 'Nie udało się dodać zestawu. Spróbuj ponownie.');
    return data;
  }
  document.addEventListener('submit', async e => {
    if (e.target !== form || document.getElementById('alarmiko-native-offer')) return;
    e.preventDefault();e.stopImmediatePropagation();
    if (busy || button.disabled) return;
    busy = true;button.disabled = true;button.setAttribute('aria-busy','true');
    try {
      const variant = product.variants[current];
      const selection = crypto.randomUUID();
      const properties = {'Zawartość zestawu':form.elements.namedItem('properties[Zawartość zestawu]').value,'Zastosowanie':'Dom','_alarmiko_selection':selection};
      const before = await cart('cart.js');
      const old = before.items.filter(item => Number(item.product_id) === Number(product.id));
      const added = await cart('cart/add.js?opens_cart=never', {items:[{id:variant.id,quantity:1,properties}]});
      if (!added.items?.length) throw new Error('Nie udało się dodać zestawu.');
      const shippingCode = 'DARMOWA-DOSTAWA-ALARMIKO-PL';
      const codes = (before.discount_codes || []).map(entry => entry.code).filter(code => code.toUpperCase() !== shippingCode);
      if (current > 0) codes.push(shippingCode);
      const updated = await cart('cart/update.js?opens_cart=never', {
        discount:codes.join(','),
        updates:Object.fromEntries(old.map(item=>[item.key,0])),
        attributes:{_alarmiko_locale:'pl',_alarmiko_view:'czujnik-czadu-dom',_alarmiko_return_url:'/pl/products/czujnik-czadu-i-gazu-do-domu'}
      });
      const line = updated.items.find(item => Number(item.variant_id) === Number(variant.id) && item.properties?._alarmiko_selection === selection);
      if (!line || line.quantity !== 1 || updated.currency !== 'PLN' || line.final_line_price > variant.price) throw new Error('Nie udało się potwierdzić ceny zestawu. Spróbuj ponownie.');
      window.location.assign('/pl/checkout?locale=pl');
    } catch (error) {
      let message = form.querySelector('[data-offer-error]');
      if (!message) {message=document.createElement('p');message.dataset.offerError='';message.setAttribute('role','alert');form.append(message);}
      message.textContent = error.message;
    } finally {busy=false;button.disabled=false;button.removeAttribute('aria-busy');}
  }, true);
})();
